const itemsOnPage = [10, 20, 30].map(item => ({
  key: item,
  value: item,
  renderElement: item,
  selectedRenderElement: item,
  active: item === 10,
}));

export { itemsOnPage };
